<!----
    Author: hjlee
    Description:
        돼지꼬리 라벨
---->
<template>
  <div>
    <div
      :class="{
        'pig-tail-label-box':true,
        'pig-tail-label-left':(horzPosition==='left'),
        'pig-tail-label-right':(horzPosition==='right'),
        'pig-tail-label-top':(vertPosition==='top'),
        'pig-tail-label-bottom':(vertPosition==='bottom')}"
    >
      <div class="clear" />
      <div
        :class="{
          'img-pig-tail':true,
          'img-pig-tail-bottom':true,
          'img-pig-tail-left':(horzPosition==='left'),
          'img-pig-tail-right':(horzPosition==='right')}"
      />
      <div class="clear" />
      <div class="pig-tail-label-description">
        <div v-html="message" />
      </div>
      <div class="clear" />
      <div
        :class="{
          'img-pig-tail':true,
          'img-pig-tail-top':true,
          'img-pig-tail-left':(horzPosition==='left'),
          'img-pig-tail-right':(horzPosition==='right')}"
      />
      <div class="clear" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    },
    position: {
      type: String,
      default: ''
    },
    noClose: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      horzPosition: 'left',
      vertPosition: 'bottom'
    }
  },
  mounted: function() {
    this.finalPosition = this.position
    if (this.finalPosition === undefined) {
      this.finalPosition = 'left bottom'
    }
    if (this.finalPosition.indexOf('right') >= 0) {
      this.horzPosition = 'right'
    } else {
      this.horzPosition = 'left'
    }
    if (this.finalPosition.indexOf('top') >= 0) {
      this.vertPosition = 'top'
    } else {
      this.vertPosition = 'bottom'
    }
    this.id = 'guide_' + this.path + '_' + this.code + '_' + this.position
  }
}
</script>

<style scoped>
@import url('//fonts.googleapis.com/earlyaccess/nanumpenscript.css');
.img-pig-tail {
  display: none;
}
.pig-tail-label-top .img-pig-tail-top {
  display: block;
}
.pig-tail-label-bottom .img-pig-tail-bottom {
  display: block;
}
.pig-tail-label-top {
  margin-top: 20px;
  margin-bottom: -5px;
}
.pig-tail-label-bottom {
  margin-top: -5px;
  margin-bottom: 20px;
}
.img-pig-tail {
  width: 40px;
  height: 35px;
}
.img-pig-tail-top.img-pig-tail-left {
  background-image: url(~assets/img/pig_tail_left_top_primary.png);
  background-size: 40px 35px;
}
.img-pig-tail-top.img-pig-tail-right {
  background-image: url(~assets/img/pig_tail_right_top_primary.png);
  background-size: 40px 35px;
}
.img-pig-tail-bottom.img-pig-tail-left {
  background-image: url(~assets/img/pig_tail_left_bottom_primary.png);
  background-size: 40px 35px;
}
.img-pig-tail-bottom.img-pig-tail-right {
  background-image: url(~assets/img/pig_tail_right_bottom_primary.png);
  background-size: 40px 35px;
}
.img-pig-tail-top {
  margin-top: 3px;
}
.img-pig-tail-left {
  margin-left: 30px;
  float: left;
}
.img-pig-tail-bottom {
  margin-bottom: 3px;
}
.img-pig-tail-right {
  margin-right: 30px;
  float: right;
}
.pig-tail-label-left .pig-tail-label-description {
  float: left;
}
.pig-tail-label-right .pig-tail-label-description {
  float: right;
}
.pig-tail-label-description {
  white-space: normal;
  font-family: 'Nanum Pen Script', serif;
  color: white;
  padding: 5px 10px;
  border-radius: 3px;
  overflow: visible;
  background-color: rgba(0, 0, 0, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  -webkit-box-shadow: 5px 5px 7px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 5px 5px 7px rgba(0, 0, 0, 0.3);
  box-shadow: 5px 5px 7px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  font-size: 1.3rem;
}
</style>
